import { render } from "./VDropdownWithKeyboardNavigation.vue?vue&type=template&id=1b54ca58&ts=true"
import script from "./VDropdownWithKeyboardNavigation.vue?vue&type=script&lang=ts"
export * from "./VDropdownWithKeyboardNavigation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__